import React from 'react';
import { useDocumentTitle } from '../../hooks';
import { useLocation } from 'react-router-dom';
import { getRouteFromPath } from '@amzn/atoz-shiftapp-initializer';

export const DocumentTitle: React.FC = () => {
    const { pathname } = useLocation();
    const pageName = getRouteFromPath(pathname);
    useDocumentTitle(pageName);
    return null;
};
